import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { HttpService, MessageService, UserService } from 'src/app/core';
import { ConstantConfig } from 'src/app/core/config/constant.config';
import { PathConfig } from 'src/app/core/config/path.config';
import { UserInfo } from 'src/app/core/models/user/user-info.model';
import { Utility } from 'src/app/core/utils/utility';
import { ValidateUSPhone } from 'src/app/core/validators';
import { ConfirmModalComponent } from 'src/app/shared/components/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-update-mobile-number',
  templateUrl: './update-mobile-number.component.html',
  styleUrl: './update-mobile-number.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UpdateMobileNumberComponent {
  updateForm!: UntypedFormGroup;
  disableSubmit: boolean = true;
  show = {
    verifyNewMobileNumber: true,
    verifyOldMobileNumberOTP: true,
    oldMobileNumberOTPfield: false,
    newMobileNumberOTPfield: false
  }
  countdown: number = 60;
  timer: any;
  @Output() onMobileNumberChanged: EventEmitter<boolean> = new EventEmitter();
  messageData: {
    errorArr: string[],
    verified: string | null
  } = {
      errorArr: [],
      verified: null
    };
  redirectData = {
    message: '',
    countdown: 10,
    timer: null as any as ReturnType<typeof setInterval>
  };
  config :any;
  US_PHONE_MASKING = ConstantConfig.US_PHONE_MASKING;
  userInfo: any;
  confirmation_id:any;
  constructor(
    private fb: UntypedFormBuilder,
    private httpService: HttpService,
    public modalService: NgbModal,
    private translateService: TranslateService,
    private userService: UserService,
    private msgService: MessageService
  ) {
    this.translateService.setDefaultLang('en');
    this.translateService.use(localStorage.getItem('Selected_Language') || 'en');
  }

  ngOnInit(): void {
    this.config = Utility.getOTPConfig();
    this.updateForm = this.fb.group({
      old_mobile_number: new UntypedFormControl('', [Validators.required, ValidateUSPhone]),
      new_mobile_number: new UntypedFormControl('', [Validators.required, ValidateUSPhone]),
      old_mobile_number_otp: new UntypedFormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
      // new_mobile_number_otp: new UntypedFormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
    });
    this.updateForm.valueChanges.subscribe(() => {
      this.messageData.errorArr = [];
      this.messageData.verified = null;
    });
    this.userInfo = this.userService.getUserInfo();
  }

  onSubmit(): void {//verify old mobile number otp and change to new mobile number
    if (this.updateForm.valid) {
      const param = {
        mobile_number: this.updateForm?.value?.old_mobile_number,
        code: this.updateForm?.value?.old_mobile_number_otp,
        confirmation_id:this.confirmation_id
      };
      this.httpService.put(PathConfig.CONFIRM_OLD_MOBILE, param).subscribe({
        next: (response) => {
          this.messageData.errorArr = [];
          // this.messageData.verified = response.message;
          // this.updateForm.reset();
          // this.redirectData.message = ` ${this.translateService.instant('You will be redirected to login')} `;
          // if (this.redirectData?.timer) {
          //   clearInterval(this.redirectData?.timer);
          // };
          // this.redirectData.countdown = 10;
          // this.redirectData.timer = setInterval(() => {
          //   this.redirectData.countdown--;
          //   if (this.redirectData.countdown === 0) {
          //     clearInterval(this.redirectData.timer);
          //     this.dismissModal('submit');
          //   }
          // }, 1000);
          this.getMeDetail();
          this.msgService.showSuccess(response.message);
          this.modalService.dismissAll();
        },
        error: (err) => {
          this.showErrorInModal(err);
        }
      });
    }
  }

  getOTP(from?: string) {//for new & old mobile number
    if (!from) {
      if (!this.updateForm.get('new_mobile_number')?.valid || !this.updateForm.get('old_mobile_number')?.valid || (this.updateForm.value?.new_mobile_number == this.updateForm.value?.old_mobile_number)) {
        return;
      }
      const param = {
        mobile_number: this.updateForm?.value?.new_mobile_number,
        old_mobile_number: this.updateForm?.value?.old_mobile_number
      };
      this.httpService.put(PathConfig.UPDATE_MOBILE, param)
        .subscribe((response) => {
          this.confirmation_id = response?.confirmation_id;
          if (this.userInfo?.enable_2fa == 'NO') {
            this.getMeDetail();
            this.msgService.showSuccess(response.message);
            this.modalService.dismissAll();
          } else {
            this.show.oldMobileNumberOTPfield = true;
            this.show.verifyOldMobileNumberOTP = false;
            this.messageData.errorArr = [];
            this.startCountdown();
          }
        }, (err) => {
          this.countdown = 0;
          this.showErrorInModal(err);
        });
    } else {
      const newMobileNumber = this.updateForm.get('new_mobile_number')?.value;
      const oldMobileNumber = this.updateForm.get('old_mobile_number')?.value;
      if (
        !this.updateForm.get('new_mobile_number')?.valid ||
        !this.updateForm.get('old_mobile_number')?.valid ||
        newMobileNumber === oldMobileNumber
      ) {
        return;
      }
      const param = {
        mobile_number: this.updateForm?.value?.new_mobile_number,
        old_mobile_number: this.updateForm?.value?.old_mobile_number,
        firstname: this.userInfo.firstname,
        lastname: this.userInfo.lastname,
      };
      this.httpService.put(PathConfig.VERIFY_NEW_MOBILE, param)
        .subscribe((response) => {
          this.show.newMobileNumberOTPfield = true;
          if (response?.opt_in_status == 'SUBSCRIBED') {
            this.show.newMobileNumberOTPfield = false;
            this.show.verifyNewMobileNumber = false;
            this.updateForm.controls.new_mobile_number_otp.clearValidators();
            this.updateForm.controls.new_mobile_number_otp.updateValueAndValidity();
            this.getOTP();
          }
          this.messageData.errorArr = [];
          this.messageData.verified = response.message;
          this.startCountdown();
        }, (err) => {
          this.countdown = 0;
          this.showErrorInModal(err);
        });
    }
  }

  startCountdown() {
    this.countdown = 60;
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  verifyNewMobileNumberOTP() {
    if (!this.updateForm.get('new_mobile_number_otp')?.valid || !this.updateForm.get('new_mobile_number')?.valid) {
      return;
    }
    const param = {
      pin: this.updateForm?.value?.new_mobile_number_otp,
      mobile_number: this.updateForm?.value?.new_mobile_number,
      // user_id: this.userInfo.id
    };
    this.httpService.put(PathConfig.CONFIRM_VBT, param)
      .subscribe(() => {
        this.show.verifyNewMobileNumber = false;
        this.show.newMobileNumberOTPfield = false;
        this.messageData.errorArr = [];
        this.messageData.verified = '';
        this.getOTP();
      }, (err) => {
        this.showErrorInModal(err);
      });
  }

  showErrorInModal(err: any) {
    this.messageData.errorArr = [];
    this.messageData.verified = '';
    if (err?.error?.message) {
      this.messageData.errorArr = this.getErrorList(err?.error) ?? [];
    } else {
      this.messageData.errorArr = ['Server Error, Please try again after some time.'];
    }
  }

  getErrorList(err: any) {
    let errorMsg = [err];
    if (err?.errors) {
      if (_.isPlainObject(err?.errors)) {
        errorMsg = _.chain(err?.errors)?.values()?.flatten()?.value();
      }
      const msgList = errorMsg?.map((msg) => {
        return msg;
      });
      return msgList;
    } else if (err?.message) {
      return [err?.message];
    } else {
      return
    }
  }

  dismissModal(from?: string) {
    if (from == 'submit') {
      this.modalService.dismissAll(this.redirectData.message ? 'logout' : 'no-logout');

    } else {
      if (this.updateForm.dirty) {
        const modalRef = this.modalService.open(ConfirmModalComponent, {
          ariaLabelledBy: 'modal-basic-title',
          centered: true,
          size: 'sm',
        });
        modalRef.componentInstance.confirmationMessage =
          `${this.translateService.instant('Are you sure you want to close?')}`;
        modalRef.result.then((response) => {
          if (response) {
            this.modalService.dismissAll(this.redirectData.message ? 'logout' : 'no-logout');
          }
        });
      } else {
        this.modalService.dismissAll(this.redirectData.message ? 'logout' : 'no-logout');
      }
    }

  }

  getMeDetail(){
    this.httpService.get(PathConfig.USER_ME).subscribe((response) => {
      this.userService.setUserInfo(new UserInfo(response.user));
    }, (err) => { });
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer);
    };
    if (this.redirectData?.timer) {
      clearInterval(this.redirectData?.timer);
    };
  }

}
